const sortPolicies = (a, b) => {
  if (a.isActive && !b.isActive) {
    return -1;
  }
  if (!a.isActive && b.isActive) {
    return 1;
  }

  if (a.openDate < b.openDate) {
    return -1;
  }
  if (a.openDate > b.openDate) {
    return 1;
  }
  if (a.openDate === b.openDate) {
    if (a.accountNo > b.accountNo) {
      return -1;
    }
    if (a.accountNo < b.accountNo) {
      return 1;
    }
  }
};

export default sortPolicies;
